import {
  GET_CHAT_MESSAGES_REQUEST,
  GET_CHAT_MESSAGES_SUCCESS,
  GET_CHAT_MESSAGES_FAILURE,
  POST_MESSAGE_TO_CHAT_REQUEST,
  POST_MESSAGE_TO_CHAT_SUCCESS,
  POST_MESSAGE_TO_CHAT_FAILURE,
  ADD_MESSAGE,
  RESET_SCROLL_TO_BOTTOM,
  RESET_CHAT,
  RELOAD_MESSAGES,
} from './actionTypes';

export const getChatMessagesRequest = () => ({ type: GET_CHAT_MESSAGES_REQUEST });
export const getChatMessagesSuccess = (messages) => ({
  type: GET_CHAT_MESSAGES_SUCCESS,
  messages,
});
export const getChatMessagesFailure = () => ({ type: GET_CHAT_MESSAGES_FAILURE });

export const postMessageToChatRequest = () => ({ type: POST_MESSAGE_TO_CHAT_REQUEST });
export const postMessageToChatSuccess = (message) => ({
  type: POST_MESSAGE_TO_CHAT_SUCCESS, message,
});
export const postMessageToChatFailure = (error) => ({ type: POST_MESSAGE_TO_CHAT_FAILURE, error });

export const addMessage = (message) => ({ type: ADD_MESSAGE, message });
export const resetScrollToBottom = () => ({ type: RESET_SCROLL_TO_BOTTOM });
export const resetChat = () => ({ type: RESET_CHAT });
export const reloadMessages = () => ({ type: RELOAD_MESSAGES });
